/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
export const calc100 = val => {
  return `calc(100% - ${val}px)`
}

export const asPx = val => {
  return `${val}px`
}

export const scrollY = {
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none !important'
  },
  '::-webkit-scrollbar': {
    display: 'none !important'
  }
}

export const marginPadding0 = {
  margin: '0',
  padding: '0'
}

export const margin0 = {
  margin: '0'
}

export const padding0 = {
  padding: '0'
}
export const widthHeight100 = {
  width: '100%',
  height: '100%'
}

export const vwvh100 = {
  width: '100vw',
  height: '100vh'
}

export const width100 = {
  width: '100%'
}

export const height100 = {
  height: '100%'
}

export const hidden = {
  display: 'none !important'
}

export const block = {
  display: 'block'
}

export const pointer = {
  '&:hover': {
    cursor: 'pointer'
  }
}

export const flex = {
  display: 'flex'
}

export const flexColCenter = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
}

export const flexRowCenter = {
  display: 'flex',
  justifyContent: 'center'
}

export const flexStart = {
  display: 'flex',
  justifyContent: 'flex-start'
}

export const flexEnd = {
  display: 'flex',
  justifyContent: 'flex-end'
}

export const flexRowSpaceBetween = {
  display: 'flex',
  justifyContent: 'space-between'
}

export const flexColSpaceBetween = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between'
}

export const flexColStart = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start'
}

export const flexCol = {
  flexDirection: 'column',
  display: 'flex'
}

export const flexCenter = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

export const alignCenter = {
  alignItems: 'center'
}

export const textCenter = {
  textAlign: 'center'
}

export const textRight = {
  textAlign: 'right'
}
export const textLeft = {
  textAlign: 'left'
}

export default {
  calc100,
  asPx,
  textCenter,
  textRight,
  textLeft,
  widthHeight100,
  width100,
  height100,
  marginPadding0,
  margin0,
  padding0,
  hidden,
  block,
  flex,
  flexEnd,
  flexStart,
  flexCol,
  flexCenter,
  flexColCenter,
  flexRowCenter,
  flexColSpaceBetween,
  pointer,
  scrollY,
  vwvh100
}
